/* TrackDNA — product-details tabs (Task 13b).
 *
 * Standard WAI-ARIA APG tabs pattern (selection follows focus): a
 * role="tablist" of role="tab" buttons, roving tabindex, arrow keys move and
 * activate. sections/turn14-product-details.liquid only prints this file's
 * <script> tag when it renders more than one tab — a single-tab product has
 * no strip and nothing here to wire.
 *
 * PROGRESSIVE ENHANCEMENT. Every panel already exists in the markup with the
 * first one visible and the rest carrying `hidden`. Without this script the
 * page still shows the description (or whichever panel is first) — worse
 * than tabbed, never broken.
 */
(function () {
  "use strict";

  function panelFor(tab) {
    var id = tab.getAttribute("aria-controls");
    return id ? document.getElementById(id) : null;
  }

  function select(tablist, tab) {
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));

    tabs.forEach(function (t) {
      var active = t === tab;
      t.setAttribute("aria-selected", active ? "true" : "false");
      t.tabIndex = active ? 0 : -1;

      var panel = panelFor(t);
      if (!panel) return;
      if (active) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  function wire(tablist) {
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        select(tablist, tab);
      });
    });

    tablist.addEventListener("keydown", function (event) {
      var current = document.activeElement;
      var i = tabs.indexOf(current);
      if (i === -1) return;

      var next = null;
      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          next = tabs[(i + 1) % tabs.length];
          break;
        case "ArrowLeft":
        case "ArrowUp":
          next = tabs[(i - 1 + tabs.length) % tabs.length];
          break;
        case "Home":
          next = tabs[0];
          break;
        case "End":
          next = tabs[tabs.length - 1];
          break;
        default:
          return;
      }

      event.preventDefault();
      next.focus();
      select(tablist, next);
    });
  }

  function boot() {
    var lists = document.querySelectorAll("[data-pdp-tabs]");
    for (var i = 0; i < lists.length; i++) wire(lists[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
